import { render, staticRenderFns } from "./ListAnnotations.vue?vue&type=template&id=c772d322&scoped=true"
import script from "./ListAnnotations.vue?vue&type=script&lang=js"
export * from "./ListAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotations.vue?vue&type=style&index=0&id=c772d322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c772d322",
  null
  
)

export default component.exports